var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amount-position"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.label)+" "),_c('span',[_vm._v("R$"+_vm._s(_vm.parseNumberToMoney(_vm.value).trim().split('$')[1])+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }